(function($) {
	'use strict';

	$.widget('msv.tableResponsive', {

		options: {
			largeAndUp: window.matchMedia('(min-width: 1024px)')
		},

		_init: function() {
			var self = this;

			this._events();
			!this.options.largeAndUp.addListener(function() {
				!self.options.largeAndUp.matches ?
					self._events() :
					$('.table-responsive__head-mobile').remove()
			})
		},

		_events: function() {

			if (!this.options.largeAndUp.matches) {

				this.element.find('tbody>tr>td').each(function(_, el) {
					$(el).prepend(function() {
						return "<div class='table-responsive__head-mobile'>".concat($(el).closest('.table-responsive').find('th:not(:first)').eq($(el).index() - 1).text(), "</div>");
					})
				})
			}
		}
	});

})(jQuery);